"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioGroup = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _generateRandomId = require("../../utils/generateRandomId");

var _useGlobalStyles = require("../../styles/global/useGlobalStyles");

var _radioGroup = require("./radioGroup.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var RadioGroup = function RadioGroup(_ref) {
  var items = _ref.items,
      selected = _ref.selected;
  (0, _useGlobalStyles.useGlobalStyles)();
  var classes = (0, _radioGroup.useStyles)();
  var randomId = (0, _generateRandomId.generateRandomId)(16);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.radioGroup
  }, items.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(RadioItem, {
      item: item,
      selected: selected,
      groupId: randomId
    });
  }));
};

exports.RadioGroup = RadioGroup;

var RadioItem = function RadioItem(_ref2) {
  var item = _ref2.item,
      selected = _ref2.selected,
      groupId = _ref2.groupId;
  var randomId = (0, _generateRandomId.generateRandomId)(16);
  var classes = (0, _radioGroup.useStyles)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.itemBox
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "radio",
    className: classes.btnRadio,
    name: "radioGroup-".concat(groupId),
    id: randomId,
    autoComplete: "off",
    onChange: function onChange(e) {
      return selected(item, e.target.checked);
    }
  }), /*#__PURE__*/_react["default"].createElement("label", {
    className: classes.itemContent,
    htmlFor: randomId
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: classes.icon
  }, item.data.icon), /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.title
  }, item.data.title)));
};

RadioGroup.propTypes = {
  // items , contain item id , picture, title
  items: _propTypes["default"].array,
  // Selected , show selected item
  selected: _propTypes["default"].func
};
RadioGroup.defaultProps = {
  items: [],
  selected: function selected() {}
};